/*!
 * Copyright (c) Trimble Inc. All rights reserved
 */

export { AppShellComponent } from './app-shell.component';
export { AppShellModule } from './app-shell.module';